/* Golden Silver Rivers theme: menus, product selection, photo gallery, bag and search.
   All product, price, stock and bag data comes from Shopify. */
(function () {
  'use strict';
  var T = window.theme || {}, R = T.routes || {}, root = document.documentElement;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var main = $('#main');
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  /* Prices arrive from Shopify in cents. They are shown in the store's own money format, without trailing zeros. */
  function money(cents) {
    var value = Number(cents) / 100;
    function group(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 && Number(parts[1]) > 0 ? parts[0] + decimal + parts[1] : parts[0];
    }
    var out = String(T.moneyFormat || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return group(Math.round(value), 0, ',', '.');
        case 'amount_with_comma_separator': return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(Math.round(value), 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(value, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return group(Math.round(value), 0, ' ', ',');
        case 'amount_with_space_separator': return group(value, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return group(value, 2, ' ', '.');
        default: return group(value, 2, ',', '.');
      }
    });
    var box = document.createElement('div'); box.innerHTML = out;
    return box.textContent;
  }
  var unpriced = function (cents) { return !(Number(cents) > 0); };

  /* ───────────── Photos ─────────────
     Shopify's image server resizes on request, so each screen downloads only the size it needs. */
  var isShopImg = function (url) { return /cdn\.shopify\.com|\/cdn\/shop\//.test(url); };
  function sized(url, w) { return isShopImg(url) ? url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=' + w : url; }
  function noimg() { return '<div class="noimg"><span>Photograph to come</span></div>'; }
  function picture(im, o) {
    o = o || {};
    if (!im || !im.url) return noimg();
    var widths = o.widths || [400, 800, 1200], shop = isShopImg(im.url);
    var srcset = shop ? widths.map(function (w) { return sized(im.url, w) + ' ' + w + 'w'; }).join(', ') : '';
    return '<img src="' + esc(shop ? sized(im.url, widths[Math.min(1, widths.length - 1)]) : im.url) + '"' +
      (srcset ? ' srcset="' + esc(srcset) + '" sizes="' + (o.sizes || '100vw') + '"' : '') + ' alt="' + esc(o.alt != null ? o.alt : im.alt) + '"' +
      (im.width && im.height ? ' width="' + im.width + '" height="' + im.height + '"' : '') + (o.eager ? ' fetchpriority="high"' : ' loading="lazy" decoding="async"') + '>';
  }

  /* ───────────── Metals ─────────────
     Reads a metal from an option name, a photo's alt text or its file name, so the gallery can follow the chosen material. */
  var PURITY = { '9K': '37.5', '10K': '41.7', '14K': '58.5', '18K': '75', '22K': '91.7', '24K': '99.9' };
  function metalOf(text) {
    var t = ' ' + String(text || '').toLowerCase().replace(/golden\s*silver\s*rivers/g, ' ').replace(/[_\-.·,/()]+/g, ' ').replace(/\s+/g, ' ') + ' ';
    var family = /vermeil/.test(t) ? 'vermeil' : /plated/.test(t) ? 'plated' : /platinum|platino/.test(t) ? 'platinum' : /gold(?!en)|\boro\b/.test(t) ? 'gold' : /silver|\bplata\b|925/.test(t) ? 'silver' : null;
    if (!family) return null;
    if (family === 'platinum') { var fine = (t.match(/\b(950|900|850)\b/) || [])[1]; return { family: family, look: 'platinum', karat: fine || '' }; }
    var karat = (t.match(/(\d{1,2}) ?k(?![a-z])/) || [])[1];
    var look = family === 'silver' ? 'silver' : /white ?gold|oro blanco/.test(t) ? 'white' : /rose ?gold|oro rosa/.test(t) ? 'rose' : 'yellow';
    return { family: family, look: look, karat: karat ? karat + 'K' : '' };
  }
  function materialNote(value, field) {
    var mt = metalOf(value), def = mt && (T.materials || {})[mt.family];
    if (!def || !def[field]) return '';
    var text = def[field], purity = mt.family === 'platinum' ? (mt.karat ? String(Number(mt.karat) / 10) : '') : PURITY[mt.karat];
    if (/\{(karat|purity|fineness)\}/.test(text) && !purity) text = def.noteGeneric || ''; // purity not stated in the option name: say less rather than guess
    return text.replace(/\{karat\}/g, mt.karat).replace(/\{fineness\}/g, mt.karat).replace(/\{purity\}/g, purity);
  }
  var isMaterial = function (o) { return /material|metal/i.test(o.name); };
  var fileName = function (url) { return decodeURIComponent(String(url).split('?')[0].split('/').pop()); };
  var imgKey = function (url) { return String(url).split('?')[0].replace(/^https?:/, ''); };
  /* Which photos show the chosen metal. The store can say so in two ways:
     (a) the photo's alt text (or file name) names the metal: every such photo is shown, and the others are left out;
     (b) one photo is assigned to the metal's variants in Shopify: that photo is shown first.
     White gold and silver look alike, so each can stand in for the other, with a note saying which one is pictured. */
  var LOOK_ALIKE = { white: ['silver', 'platinum'], silver: ['white', 'platinum'], platinum: ['white', 'silver'] };
  var LOOK_NAME = { silver: 'sterling silver', white: 'white gold', platinum: 'platinum' };
  function photosOf(p, mo, chosen) {
    var want = metalOf(chosen), byVariant = {}, distinct = {};
    p.variants.forEach(function (v) { if (v.image) distinct[imgKey(v.image.url)] = 1; });
    var variantPhotos = Object.keys(distinct).length > 1; // one shared photo means Shopify is only repeating the main photo
    if (variantPhotos) p.variants.forEach(function (v) {
      if (v.image && v.selectedOptions.some(function (o) { return o.name === mo.name && o.value === chosen; })) byVariant[imgKey(v.image.url)] = 1;
    });
    var kinds = p.images.map(function (im) { return metalOf((im.alt || '') + ' ' + fileName(im.url)); });
    var byLook = function (look) { return p.images.filter(function (im, i) { return kinds[i] && kinds[i].look === look; }); };
    var labelled = want ? byLook(want.look) : [], standIn = '';
    if (want && !labelled.length) (LOOK_ALIKE[want.look] || []).some(function (look) { labelled = byLook(look); if (labelled.length) standIn = look; return labelled.length; });
    return {
      assigned: p.images.filter(function (im) { return byVariant[imgKey(im.url)]; }), labelled: labelled, standIn: standIn,
      unlabelled: p.images.filter(function (im, i) { return !kinds[i]; }), anyLabelled: kinds.some(Boolean), want: want
    };
  }
  function baseGallery(p, sel) {
    var mo = p.options.filter(isMaterial)[0], chosen = mo && sel[mo.name];
    if (!chosen || !p.images.length) return { images: p.images, note: '' };
    var f = photosOf(p, mo, chosen), seen = {};
    var uniq = function (list) { return list.filter(function (im) { var k = imgKey(im.url); if (seen[k]) return false; seen[k] = 1; return true; }); };
    if (f.labelled.length) {
      var note = f.standIn ? 'Photos show this piece in ' + LOOK_NAME[f.standIn] + '.'
        : (f.want.family === 'plated' || f.want.family === 'vermeil') && !f.assigned.length ? 'Photos show this piece in yellow gold.' : '';
      return { images: uniq(f.assigned.concat(f.labelled)), note: note };
    }
    if (f.assigned.length) { // one photo is marked for this metal; the rest say nothing about theirs
      var images = uniq(f.assigned.concat(f.unlabelled));
      return { images: images, note: images.length > f.assigned.length ? 'The first photo shows ' + chosen + '. Other photos may show other metals.' : '' };
    }
    return { images: p.images, note: f.anyLabelled ? 'There are no photos of ' + chosen + ' yet. The photos shown are of other metals.' : '' };
  }

  /* Small notice board, so the try-on script (loaded only on request) can follow what happens on the page. */
  var hooks = {};
  function on(name, fn) { (hooks[name] = hooks[name] || []).push(fn); }
  function emit(name, data) { (hooks[name] || []).forEach(function (fn) { try { fn(data); } catch (e) { if (window.console) console.error(e); } }); }
  /* Shopper actions are reported to Shopify's own analytics as plain facts (which piece, which step). Never pictures or camera data. */
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('gsr:' + name, data || {}); } catch (e) { /* analytics must never break shopping */ }
    try { document.dispatchEvent(new CustomEvent('gsr:analytics', { detail: { name: name, data: data || {} } })); } catch (e2) { /* older browsers */ }
  }

  /* ───────────── Panels and dialogs ───────────── */
  var openPanel = null, lastFocus = null, scrim = $('.scrim'), bar = $('#buybar');
  function behind() { return [$('.skip'), $('.announce'), $('.site-header'), main, $('.site-footer'), bar].filter(Boolean); }
  function adoptMenu() { // the menu is written inside the header section; it must sit at the end of the page to slide over everything
    var fresh = $$('#menu-panel').filter(function (el) { return el.parentNode !== document.body; })[0];
    if (!fresh) return;
    $$('#menu-panel').forEach(function (el) { if (el !== fresh) el.remove(); });
    document.body.appendChild(fresh);
  }
  function open(id, opener) {
    closePanels(true);
    lastFocus = opener || document.activeElement;
    openPanel = $('#' + id);
    if (!openPanel) return;
    openPanel.inert = false;
    openPanel.classList.add('is-open');
    scrim.classList.add('is-on');
    root.classList.add('locked');
    behind().forEach(function (el) { el.inert = true; }); // keyboard and screen readers stay inside the open panel
    syncBuybar();
    var f = $('[data-autofocus]', openPanel) || $('button, a, input', openPanel);
    if (f) setTimeout(function () { f.focus(); if (f.select) f.select(); }, 60);
  }
  function closePanels(silent) {
    if (!openPanel) return;
    var closing = openPanel.id;
    openPanel.classList.remove('is-open');
    openPanel.inert = true;
    openPanel = null;
    emit('close:' + closing); // the try-on overlay stops the camera here, however it was closed
    scrim.classList.remove('is-on');
    root.classList.remove('locked');
    behind().forEach(function (el) { el.inert = false; });
    syncBuybar();
    if (silent) return;
    if (lastFocus && lastFocus.isConnected && lastFocus.focus) lastFocus.focus({ preventScroll: true }); else if (main) main.focus({ preventScroll: true });
  }
  var toastTimer;
  function toast(msg) {
    var t = $('#toast'); t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 4200);
  }

  /* ───────────── Bag (Shopify's Ajax Cart API) ───────────── */
  var cart = null, chain = Promise.resolve(), pending = 0, want = {}; // want: quantities tapped but not yet confirmed by Shopify
  var madeToOrder = {}, asked = {};
  function normCart(c) {
    return {
      quantity: c.item_count, subtotal: c.total_price,
      lines: (c.items || []).map(function (i) {
        return { id: i.key, quantity: i.quantity, variantId: i.variant_id, title: i.product_title, handle: i.handle, url: i.url,
          original: i.original_line_price || i.final_line_price, savings: (i.line_level_discount_allocations || []).map(function (a) { return a.discount_application && a.discount_application.title; }).filter(Boolean),
          options: (i.options_with_values || []).filter(function (o) { return !(i.product_has_only_default_variant || o.value === 'Default Title'); }),
          image: i.image ? { url: String(i.image).replace(/^https?:/, ''), alt: '' } : null, price: i.final_price, total: i.final_line_price };
      })
    };
  }
  async function request(url, body) {
    var res = await fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
    var json = null;
    try { json = await res.json(); } catch (e) { /* not JSON */ }
    if (!res.ok) { var err = new Error((json && (json.description || json.message)) || 'The bag could not be updated.'); err.shopify = !!json; throw err; }
    return json;
  }
  var fetchCart = function () { return request(R.cart + '.js').then(normCart); };
  var qtyOf = function (c, variantId) { return c ? c.lines.filter(function (l) { return l.variantId === variantId; }).reduce(function (a, l) { return a + l.quantity; }, 0) : 0; };
  async function addLine(variantId, qty, title) {
    var before = qtyOf(cart, variantId);
    await request(R.cartAdd + '.js', { items: [{ id: variantId, quantity: qty }] });
    var next = await fetchCart(), got = qtyOf(next, variantId);
    if (got < before + qty) next.notice = 'Only ' + got + ' of ' + title + ' ' + (got === 1 ? 'is' : 'are') + ' available, so the quantity was set to ' + got + '.';
    return next;
  }
  async function changeLine(key, qty) { return normCart(await request(R.cartChange + '.js', { id: key, quantity: qty })); }
  function lineQty(id) { var l = cart && cart.lines.filter(function (x) { return x.id === id; })[0]; return l ? l.quantity : 0; }
  function setBusy() { $$('[data-cart-foot]').forEach(function (f) { if (pending) f.setAttribute('aria-busy', 'true'); else f.removeAttribute('aria-busy'); }); }
  function learnTags() { // "Made to order" comes from a product tag, which the bag itself does not carry
    if (!cart) return;
    cart.lines.forEach(function (l) {
      if (asked[l.handle]) return;
      asked[l.handle] = true;
      request(R.root.replace(/\/$/, '') + '/products/' + l.handle + '.js').then(function (p) {
        var tags = typeof p.tags === 'string' ? p.tags.split(',') : (p.tags || []);
        if (tags.some(function (t) { return /made[ -]to[ -]order/i.test(t); })) { madeToOrder[l.handle] = true; paintBag(); }
      }).catch(function () { /* the note is optional */ });
    });
  }
  function paintBag(note) {
    var n = cart ? cart.quantity : 0;
    $$('[data-bag-count]').forEach(function (el) { el.textContent = n; if (el.classList.contains('bag-dot')) { if (n) el.removeAttribute('data-empty'); else el.setAttribute('data-empty', ''); } });
    var empty = !cart || !cart.lines.length;
    var lines = empty ? '<div class="bag-empty"><h2>Your bag is empty</h2><p>Pieces you add will wait for you here.</p><a class="btn" href="' + esc(R.all) + '">View all pieces</a></div>'
      : cart.lines.map(function (l) {
        var q = want[l.id] != null ? want[l.id] : l.quantity;
        return '<div class="line' + (q < 1 ? ' is-removing' : '') + '" data-line="' + esc(l.id) + '"><a class="line-media" href="' + esc(l.url) + '" tabindex="-1" aria-hidden="true">' + picture(l.image, { widths: [200, 400], sizes: '90px', alt: '' }) + '</a>' +
          '<div class="line-info"><div class="line-top"><a href="' + esc(l.url) + '">' + esc(l.title) + '</a><span class="price">' + (l.original > l.total ? '<s>' + esc(money(l.original)) + '</s> ' : '') + esc(money(l.total)) + '</span></div>' +
          (l.options.length ? '<ul class="line-opts">' + l.options.map(function (o) { return '<li>' + esc(o.name) + ': ' + esc(o.value) + '</li>'; }).join('') + '</ul>' : '') +
          (l.quantity > 1 ? '<p class="line-note">' + (l.options.some(function (o) { return /ring size/i.test(o.name); }) ? l.quantity + ' rings · ' : '') + esc(money(l.original > l.total ? l.original / l.quantity : l.price)) + ' each</p>' : '') +
          (l.savings.length ? '<p class="line-note line-saving">' + esc(l.savings.join(', ')) + '</p>' : '') +
          (T.allMade || madeToOrder[l.handle] ? '<p class="line-note">' + esc(T.productionLine || 'Made to order.') + '</p>' : '') +
          '<div class="line-actions"><div class="stepper" role="group" aria-label="Quantity for ' + esc(l.title) + '">' +
          '<button type="button" data-action="line-dec" data-id="' + esc(l.id) + '" aria-label="Decrease quantity">&minus;</button><output>' + Math.max(q, 0) + '</output>' +
          '<button type="button" data-action="line-inc" data-id="' + esc(l.id) + '" aria-label="Increase quantity">+</button></div>' +
          '<button class="remove" type="button" data-action="line-remove" data-id="' + esc(l.id) + '">Remove</button></div></div></div>';
      }).join('');
    $$('[data-cart-lines]').forEach(function (body) { body.innerHTML = lines; });
    $$('[data-cart-extra]').forEach(function (el) { el.hidden = empty; });
    $$('[data-cart-foot]').forEach(function (foot) {
      var drawer = !!foot.closest('#bag-panel');
      foot.innerHTML = empty ? '' : '<div class="subtotal"><span class="label">Subtotal</span><strong>' + esc(money(cart.subtotal)) + '</strong></div>' +
        '<p class="bag-note">Shipping and taxes are calculated at checkout, before you pay.</p>' +
        (note ? '<p class="bag-msg" role="alert">' + esc(note) + '</p>' : '') +
        '<form action="' + esc(R.cart) + '" method="post"><button class="btn btn-block" type="submit" name="checkout">Secure checkout</button></form>' +
        (drawer ? '<button class="remove keep-browsing" type="button" data-action="close-panels">Continue browsing</button>' : '');
    });
    learnTags();
  }
  /* Bag changes run one after another, so quick taps are never lost, and the bag repaints without dropping keyboard focus. */
  function cartOp(fn) {
    pending++; setBusy();
    chain = chain.then(async function () {
      var ok = true, ae = document.activeElement, holder = ae && ae.closest && ae.closest('[data-cart-lines], [data-cart-foot]');
      var key = holder ? [ae.getAttribute('data-action'), ae.getAttribute('data-id')] : null, scope = holder ? holder.parentNode : null;
      try { cart = await fn(); paintBag(cart.notice); if (cart.notice) toast(cart.notice); }
      catch (e) {
        ok = false; want = {};
        if (window.console) console.error(e);
        var msg = e.shopify ? e.message : 'That change did not go through. Please try again.';
        try { cart = await fetchCart(); } catch (e2) { /* keep the last known bag */ }
        paintBag(msg); toast(msg);
      }
      pending--; setBusy();
      if (key && scope && !(document.activeElement && document.activeElement.closest('[data-cart-lines], [data-cart-foot]'))) {
        var again = $$('[data-action]', scope).filter(function (el) { return el.getAttribute('data-action') === key[0] && el.getAttribute('data-id') === key[1]; })[0];
        var fallback = again || $('.bag-empty a', scope) || $('[data-action="close-panels"]', scope);
        if (fallback) fallback.focus({ preventScroll: true });
      }
      return ok;
    });
    return chain;
  }
  function setLineQty(id, q) { // show the new number at once, then confirm it with Shopify
    want[id] = q;
    $$('[data-cart-lines] .line').forEach(function (row) {
      if (row.getAttribute('data-line') !== id) return;
      $('output', row).textContent = Math.max(q, 0); if (q < 1) row.classList.add('is-removing');
    });
    cartOp(async function () {
      var target = want[id];
      if (target == null || target === lineQty(id)) { if (target != null) delete want[id]; return cart; }
      var next = await changeLine(id, Math.max(target, 0)), line = cart.lines.filter(function (l) { return l.id === id; })[0];
      if (want[id] === target) delete want[id]; // a newer tap arrived meanwhile: leave it for the next step in the queue
      var got = next.lines.filter(function (l) { return l.id === id; })[0];
      if (line && target > 0 && got && got.quantity < target) next.notice = 'Only ' + got.quantity + ' of ' + line.title + ' ' + (got.quantity === 1 ? 'is' : 'are') + ' available, so the quantity was set to ' + got.quantity + '.';
      return next;
    });
  }

  /* ───────────── Product page ─────────────
     Nothing is chosen for the customer: every option with more than one value must be picked before adding to the bag. */
  var pv = null;
  function initProduct() {
    var holder = $('#product-data'), rootEl = $('[data-product-root]');
    pv = null;
    if (!holder || !rootEl) { syncBuybar(); return; }
    var data;
    try { data = JSON.parse(holder.textContent); } catch (e) { return; }
    var raw = data.product, names = (data.options || []).map(function (o) { return o.name; });
    var product = {
      id: raw.id, handle: raw.handle, title: raw.title, type: raw.type || '', available: !!raw.available,
      made: rootEl.getAttribute('data-made-to-order') === 'true', production: !!$('#pv-production'),
      options: (data.options || []).map(function (o) { return { name: o.name, values: (o.values || []).map(function (v) { return typeof v === 'string' ? v : (v && v.name) || String(v); }) }; }),
      images: (raw.media || []).filter(function (m) { return m.media_type !== 'model'; }).map(function (m) {
        var pre = m.preview_image || {}, src = m.media_type === 'image' ? (m.src || pre.src) : pre.src;
        return src ? { url: String(src).replace(/^https?:/, ''), alt: m.alt || '', width: m.width || pre.width || 0, height: m.height || pre.height || 0 } : null;
      }).filter(Boolean),
      variants: (raw.variants || []).map(function (v) {
        return { id: v.id, available: !!v.available, price: v.price, compareAt: v.compare_at_price > v.price ? v.compare_at_price : 0,
          selectedOptions: names.map(function (n, i) { return { name: n, value: v.options[i] }; }),
          image: v.featured_image && v.featured_image.src ? { url: String(v.featured_image.src).replace(/^https?:/, '') } : null };
      })
    };
    pv = { product: product, sel: {}, qty: 1, img: 0, error: '' };
    var start = product.variants.filter(function (v) { return v.id === data.selected; })[0];
    if (start) start.selectedOptions.forEach(function (o) { pv.sel[o.name] = o.value; });
    product.options.forEach(function (o) { if (o.values.length === 1) pv.sel[o.name] = o.values[0]; });
    pv.gallery = galleryFor(product, pv.sel);
    var form = $('#product-form');
    if (form && !$('input[type="hidden"][name="id"]', form)) { var idInput = document.createElement('input'); idInput.type = 'hidden'; idInput.name = 'id'; form.appendChild(idInput); }
    if (pv.gallery.images.length !== product.images.length || pv.gallery.note) repaintGallery();
    paintMaterials();
    pv.tryon = data.tryon || null; pv.model3d = !!data.model3d; pv.assets = data.assets || {};
    syncTools();
    initStack();
    syncBuy();
    track('product_viewed', { product_handle: product.handle, product_id: product.id, page_version: T.pageVersion || 'standard' }); // lets the two page versions be compared
  }
  /* ───────────── Virtual try-on and 3D view: entry point only ─────────────
     The buttons appear only when there is something real behind them. The overlay itself (script and styles) is fetched
     when a shopper asks for it, so ordinary browsing never pays for it. */
  function tryonModels() { // "18K Yellow Gold = abc123" per line → { '18k yellow gold': 'abc123' }
    var cfg = pv && pv.tryon, list = cfg && cfg.models, map = {};
    (Array.isArray(list) ? list : String(list || '').split(/\n|;;/)).forEach(function (line) {
      line = String(line); var i = line.indexOf('='); if (i < 1) return;
      var key = line.slice(0, i).trim().toLowerCase(), id = line.slice(i + 1).trim();
      if (key && id) map[key] = id;
    });
    return map;
  }
  function tryonSource(id) { // a full secure address, or an ID placed into the provider's address
    var url = pv.tryon && pv.tryon.provider && pv.tryon.provider.url || '', ok = location.hostname === 'localhost' ? /^https:\/\/|^http:\/\/localhost[:/]/i : /^https:\/\//i; // secure addresses only
    if (!id) return '';
    if (ok.test(id)) return id;
    return ok.test(url) && url.indexOf('{model}') >= 0 ? url.replace(/\{model\}/g, encodeURIComponent(id)) : '';
  }
  function tryonFor(material) { // the try-on address for one material ('' when there is none)
    var map = tryonModels();
    return tryonSource((material != null && map[String(material).toLowerCase()]) || map['default'] || map['all'] || '');
  }
  function tryonMaterials() { // only metals this piece is actually offered in, and only those with a model
    var mo = pv.product.options.filter(isMaterial)[0];
    return mo ? mo.values.filter(function (v) { return !!tryonFor(v); }) : [];
  }
  function tryonUsable() {
    if (!pv || !pv.tryon || !window.isSecureContext) return false; // browsers only allow the camera on secure pages
    var mo = pv.product.options.filter(isMaterial)[0];
    return mo ? tryonMaterials().length > 0 : !!tryonFor(null);
  }
  function syncTools() {
    var t = $('[data-action="tryon"][data-mode="tryon"]'), m = $('[data-action="tryon"][data-mode="3d"]'), usable = tryonUsable();
    if (pv.tryon && pv.tryon.design && !pv.tryon.preview && !usable) { // theme editor: everything is set except a working provider address
      pv.tryon.preview = true;
      pv.tryon.todo = ['Add the provider\'s secure try-on address under Theme settings > Virtual try-on, and check each line of tryon.models names a material this piece is offered in.'];
    }
    if (t) t.hidden = !(pv.tryon && (pv.tryon.preview || usable));
    if (m) m.hidden = !(pv.model3d && $('template[data-model3d]'));
  }
  /* The overlay needs both its script and its styles. Each is fetched once, and fetched again next time if it failed. */
  var tryonParts = {};
  function fetchPart(kind, url) {
    if (!tryonParts[kind]) tryonParts[kind] = new Promise(function (resolve, reject) {
      var el = document.createElement(kind === 'style' ? 'link' : 'script');
      el.onload = resolve;
      el.onerror = function () { el.remove(); tryonParts[kind] = null; reject(new Error('try-on ' + kind + ' did not load')); };
      if (kind === 'style') { el.rel = 'stylesheet'; el.href = url; } else { el.async = true; el.src = url; }
      document.head.appendChild(el);
    });
    return tryonParts[kind];
  }
  function loadTryon() {
    return Promise.all([fetchPart('style', pv.assets.style), fetchPart('script', pv.assets.script)]).then(function () {
      if (!T.tryon) { tryonParts.script = null; throw new Error('try-on did not start'); }
      return T.tryon;
    });
  }
  var tryonOpening = false;
  function launchTryon(button) {
    if (!pv || tryonOpening) return; // one request at a time, whichever button was pressed
    var mode = button.getAttribute('data-mode') === '3d' ? '3d' : 'tryon', label = button.textContent;
    var settle = function () { tryonOpening = false; button.removeAttribute('aria-disabled'); button.textContent = label; };
    tryonOpening = true; button.setAttribute('aria-disabled', 'true'); button.textContent = 'Opening…';
    loadTryon().then(function (api) { settle(); api.open(mode, button); }, function () {
      settle();
      toast('That could not open just now. The photos are still here.');
      track('tryon_failed', { product_handle: pv.product.handle, mode: mode, reason: 'script' });
    });
  }
  function choose(name, value) { // pick an option on the page itself, exactly as tapping it would
    var input = $$('#pv-buy input[data-option]').filter(function (i) { return i.getAttribute('data-option') === name && i.value === value; })[0];
    if (!input || input.checked) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* Quantity, for pieces without the stack builder. */
  function setQty(n) {
    pv.qty = Math.min(10, Math.max(1, n));
    var out = $('#qty-out'); if (out) out.textContent = pv.qty;
    var qi = $('#qty-input'); if (qi) qi.value = pv.qty;
    syncBuy();
  }

  /* ───────────── Build your beehive ─────────────
     Ring 01 is the choice made on the page itself. Rings 02 and 03 are the same ring, each with its own size and metal;
     until changed they follow Ring 01. From the fourth ring either width may be chosen, up to six rings.
     Every ring is a real Shopify variant at its Shopify price. Any saving shown is only an estimate of Shopify's
     automatic discounts; the bag and checkout show what Shopify actually applies. */
  var stk = null, MAX_RINGS = 6;
  var pad2 = function (n) { return (n < 10 ? '0' : '') + n; };
  var shortName = function (n) { return isMaterial({ name: n }) ? 'Metal' : /size/i.test(n) ? 'Size' : n; };
  function initStack() {
    stk = null;
    var box = $('[data-stack]'), el = box && $('script[data-stack-data]', box), d;
    if (!box || !el || !pv) return;
    try { d = JSON.parse(el.textContent); } catch (e) { return; }
    var prods = (d.products || []).filter(function (p) { return p && p.variants && p.variants.length; }).map(function (p) {
      var m = /(\d+(?:\.\d+)?)\s*mm\b/i.exec(p.title || '');
      return { id: p.id, handle: p.handle, title: p.title, width: p.width || (m ? m[1] + 'mm' : p.title), names: p.options || [],
        values: (p.options || []).map(function (n, i) { var seen = {}, out = []; p.variants.forEach(function (v) { var x = v.options[i]; if (x != null && !seen[x]) { seen[x] = 1; out.push(x); } }); return out; }),
        variants: p.variants.map(function (v) { return { id: v.id, price: Number(v.price), available: !!v.available, options: v.options || [] }; }) };
    });
    var main = prods.filter(function (p) { return p.id === pv.product.id; })[0];
    if (!main) return;
    main.values = main.names.map(function (n, i) { var o = pv.product.options.filter(function (x) { return x.name === n; })[0]; return o ? o.values : main.values[i]; }); // the page's own order
    stk = { box: box, prods: prods, main: main, rings: [null], count: 1, on: !!d.on, save2: Number(d.save2) || 0, save3: Number(d.save3) || 0,
      combine: !!d.combine, text: d.text || {}, name: d.name || '', error: '', tried: false, fresh: -1, busy: false, html: '', photos: d.photos || null, view: 'studio', shown: '' };
    var asked = 1; try { asked = Number(new URL(location.href).searchParams.get('stack')) || 1; } catch (e) { /* plain address */ }
    if (asked >= 2 && asked <= 3) setCount(asked, true); // an ad can open on a double or triple stack: ?stack=2
  }
  var prodOf = function (id) { return stk.prods.filter(function (p) { return p.id === id; })[0] || stk.main; };
  function adaptSel(p, sel) { // carry a choice over to a ring, keeping only values that ring is offered in
    var out = {};
    p.names.forEach(function (n, i) { if (sel[n] != null && p.values[i].indexOf(sel[n]) >= 0) out[n] = sel[n]; else if (p.values[i].length === 1) out[n] = p.values[i][0]; });
    return out;
  }
  function ringAt(i) {
    if (i === 0 || !stk.rings[i]) return { p: stk.main, sel: pv.sel, linked: i > 0 };
    var r = stk.rings[i], p = prodOf(r.pid);
    return { p: p, sel: r.linked ? adaptSel(p, pv.sel) : r.sel, linked: r.linked };
  }
  function ringVariant(p, sel) {
    if (p.names.some(function (n) { return sel[n] == null; })) return null;
    return p.variants.filter(function (v) { return p.names.every(function (n, k) { return v.options[k] === sel[n]; }); })[0] || null;
  }
  function ringState(i) {
    var r = ringAt(i), miss = r.p.names.filter(function (n) { return r.sel[n] == null; }), v = ringVariant(r.p, r.sel);
    if (miss.length) return { r: r, missing: true, msg: 'Choose ' + listNames(miss.map(shortName)) + ' for Ring ' + pad2(i + 1) + '.' };
    if (!v) return { r: r, msg: 'This combination is not offered. Choose another size or metal.' };
    if (!v.available) return { r: r, v: v, msg: 'This combination is sold out. Choose another size or metal.' };
    if (unpriced(v.price)) return { r: r, v: v, msg: 'Price on request. Choose another size or metal.' };
    return { r: r, v: v, ok: true };
  }
  function estimate(items) { // items: [{ p, v }]. Shopify counts the rings of each width; the larger saving wins when savings don't combine
    var regular = 0, groups = [], byId = {};
    items.forEach(function (it) { regular += it.v.price; var g = byId[it.p.id]; if (!g) { g = byId[it.p.id] = { p: it.p, n: 0, sum: 0 }; groups.push(g); } g.n++; g.sum += it.v.price; });
    var saves = [];
    if (stk.on) groups.forEach(function (g) { var rate = g.n >= 3 ? stk.save3 : g.n === 2 ? stk.save2 : 0; if (rate > 0) saves.push({ p: g.p, n: g.n, rate: rate, amount: Math.round(g.sum * rate / 100) }); });
    var dropped = 0;
    if (!stk.combine && saves.length > 1) { saves.sort(function (a, b) { return b.amount - a.amount; }); dropped = saves.length - 1; saves = saves.slice(0, 1); }
    var off = saves.reduce(function (a, x) { return a + x.amount; }, 0);
    return { regular: regular, saves: saves, dropped: dropped, total: regular - off, groups: groups };
  }
  function setCount(n, quiet) {
    n = Math.max(1, Math.min(MAX_RINGS, n));
    for (var k = 1; k < n; k++) if (!stk.rings[k]) stk.rings[k] = { pid: stk.main.id, linked: true, sel: {} };
    stk.fresh = n > stk.count ? stk.count : -1;
    stk.count = n; stk.error = '';
    if (!quiet) track('stack_changed', { product_handle: pv.product.handle, rings: n, page_version: T.pageVersion || 'standard' });
    syncBuy();
  }
  function removeRing(i) {
    if (!stk || i < 3 || i >= stk.count) return;
    stk.rings.splice(i, 1); stk.count--; stk.fresh = -1; stk.error = '';
    syncBuy();
    var next = $('[data-ring-card="' + i + '"] select', stk.box) || $('[data-action="stack-more"]', stk.box) || $('[data-ring-card="' + (i - 1) + '"] select', stk.box);
    if (next) next.focus({ preventScroll: true });
  }
  function stackLabel(n) { return n === 2 ? 'Add double stack to bag' : n === 3 ? 'Add triple stack to bag' : 'Add ' + n + ' rings to bag'; }
  function stackStates() { var out = []; for (var i = 0; i < stk.count; i++) out.push(ringState(i)); return out; }
  function stackTotal() { // the estimated total, once every ring is complete
    var states = stackStates();
    return states.every(function (x) { return x.ok; }) ? estimate(states.map(function (x) { return { p: x.r.p, v: x.v }; })) : null;
  }
  function ringCard(i, st) {
    var r = st.r, p = r.p, id = 'stk-' + i, extra = i >= 3, many = stk.prods.length > 1;
    var head = '<div class="ring-head"><span class="ring-no" id="' + id + '-l">Ring ' + pad2(i + 1) + '</span>' +
      '<span class="ring-width">' + esc(p.width) + '</span>' + (i > 0 && r.linked ? '<span class="ring-tag">Same as Ring 01</span>' : '') +
      '<span class="ring-price">' + (st.v && !unpriced(st.v.price) ? esc(money(st.v.price)) : '') + '</span></div>';
    var widths = extra && many ? '<div class="ring-widths" role="radiogroup" aria-label="Ring ' + pad2(i + 1) + ' width">' + stk.prods.map(function (q, k) {
      return '<label class="ring-w"><input type="radio" id="' + id + '-w' + k + '" name="' + id + '-w" value="' + q.id + '" data-ring-w="' + i + '"' + (q.id === p.id ? ' checked' : '') + '><span>' + esc(q.width) + '</span></label>';
    }).join('') + '</div>' : '';
    var fields = p.names.map(function (n, k) {
      var vals = p.values[k]; if (vals.length < 2) return '';
      var cur = r.sel[n], kind = isMaterial({ name: n }) ? 'metal' : /size/i.test(n) ? 'size' : 'other';
      var opts = (cur == null ? '<option value="" selected disabled>Choose</option>' : '') + vals.map(function (val) {
        var probe = Object.assign({}, r.sel); probe[n] = val;
        var out = !p.variants.some(function (v) { return v.available && p.names.every(function (m, j) { return probe[m] == null || v.options[j] === probe[m]; }); });
        return '<option value="' + esc(val) + '"' + (val === cur ? ' selected' : '') + '>' + esc(val) + (out ? ' (sold out)' : '') + '</option>';
      }).join('');
      return '<label class="ring-field ring-field-' + kind + '"><span>' + esc(shortName(n)) + '</span><select id="' + id + '-o' + k + '" data-ring="' + i + '" data-ring-opt="' + esc(n) + '"' + (st.missing && stk.tried && cur == null ? ' aria-invalid="true"' : '') + '>' + opts + '</select></label>';
    }).join('');
    var showMsg = !st.ok && i > 0 && (!st.missing || stk.tried);
    return '<div class="ring-card' + (stk.fresh >= 0 && i >= stk.fresh ? ' is-new' : '') + (extra && p.id !== stk.main.id ? ' is-other' : '') + '" role="group" aria-labelledby="' + id + '-l" data-ring-card="' + i + '">' +
      head + widths + '<div class="ring-fields">' + fields + '</div>' +
      (showMsg ? '<p class="ring-msg">' + esc(st.msg) + '</p>' : '') +
      (extra ? '<button class="ring-remove" type="button" data-action="stack-remove" data-ring="' + i + '" aria-label="Remove Ring ' + pad2(i + 1) + '">Remove</button>' : '') + '</div>';
  }
  function sumRows(states) {
    var ready = states.filter(function (x) { return x.ok; });
    if (ready.length < states.length) return '<p class="sum-wait">Choose a size and metal for each ring to see your total.</p>';
    var est = estimate(ready.map(function (x) { return { p: x.r.p, v: x.v }; })), mixed = est.groups.length > 1, notes = [];
    var row = function (label, value, cls) { return '<div class="sum-row' + (cls ? ' ' + cls : '') + '"><span>' + esc(label) + '</span><span>' + value + '</span></div>'; };
    var html = est.saves.length ? row('Regular price', esc(money(est.regular))) : '';
    est.saves.forEach(function (x) { html += row((mixed ? x.p.width + ' stack' : 'Stack') + ' savings (' + x.rate + '%)', '&minus;' + esc(money(x.amount)), 'sum-save'); });
    html += row(est.saves.length ? 'Estimated total' : 'Total for ' + states.length + ' rings', esc(money(est.total)), 'sum-total');
    if (est.saves.length) notes.push('Shopify applies the saving in your bag and at checkout, where the final total is shown.');
    if (est.dropped) notes.push('Shopify gives one stack saving per order: the larger one.');
    if (stk.on && stk.combine) est.groups.forEach(function (g) { if (g.n === 1 && stk.save2 > 0) notes.push('Add a second ' + g.p.width + ' ring for ' + stk.save2 + '% savings on the ' + g.p.width + ' rings.'); });
    var handles = stk.prods.map(function (p) { return p.handle; });
    if (stk.on && cart && cart.lines.some(function (l) { return handles.indexOf(l.handle) >= 0; })) notes.push('Rings already in your bag also count toward Shopify\'s stack savings.');
    if (est.groups.some(function (g) {
      var sizeName = g.p.names.filter(function (n) { return /size/i.test(n); })[0], seen = {};
      ready.forEach(function (x) { if (x.r.p.id === g.p.id && sizeName) seen[x.r.sel[sizeName]] = 1; });
      return Object.keys(seen).length > 1;
    })) notes.push('Rings in different sizes fit different fingers, so they won\'t sit together on one finger.');
    return html + notes.map(function (t) { return '<p class="sum-note">' + esc(t) + '</p>'; }).join('');
  }
  function paintStack(st, v) {
    if (!stk) return;
    var box = stk.box, n = stk.count, states = stackStates();
    $$('[data-stack-n]', box).forEach(function (input) {
      var k = Number(input.value), save = Number(input.getAttribute('data-save')) || 0, el = $('[data-stack-price="' + k + '"]', box);
      input.checked = k === Math.min(n, 3);
      if (!el) return;
      var list = []; for (var j = 0; j < k; j++) list.push(j === 0 || !stk.rings[j] ? states[0] || ringState(0) : ringState(j));
      var unit = v ? Number(v.price) : null;
      if (unit == null) { var nums = matching(pv.sel).map(function (x) { return Number(x.price); }).filter(function (c) { return c > 0; }); unit = nums.length ? Math.min.apply(null, nums) : 0; }
      var full = unit * k, after = Math.round(full * (100 - save) / 100), from = v ? '' : 'From ';
      if (list.every(function (x) { return x.ok; })) { var e = estimate(list.map(function (x) { return { p: x.r.p, v: x.v }; })); full = e.regular; after = e.total; }
      el.innerHTML = !(unit > 0) ? '' : after < full ? '<s>' + esc(money(full)) + '</s> ' + esc(from + money(after)) : esc(from + money(full));
    });
    var rings = $('[data-stack-rings]', box), html = n > 1 ? states.map(function (x, i) { return ringCard(i, x); }).join('') : '';
    if (html !== stk.html) { // rebuilt only when something changed, so a choice in progress keeps its focus
      var ae = document.activeElement, keep = ae && rings.contains(ae) ? ae.id : '';
      rings.innerHTML = html; stk.html = html; rings.hidden = n < 2;
      var back = keep && document.getElementById(keep); if (back) back.focus({ preventScroll: true });
    }
    stk.fresh = -1;
    paintView(states); regallery();
    var sum = $('[data-stack-sum]', box), sh = n > 1 ? sumRows(states) : '';
    if (sum.innerHTML !== sh) sum.innerHTML = sh;
    sum.hidden = n < 2;
    if (stk.tried && states.every(function (x) { return x.ok; })) { stk.tried = false; stk.error = ''; }
    var t = stk.text, on = stk.on && (stk.save2 > 0 || stk.save3 > 0);
    var fill = function (s) { return String(s || '').replace(/\[name\]/g, stk.name || 'matching').replace(/\[save2\]/g, stk.save2).replace(/\[save3\]/g, stk.save3).replace(/\s+/g, ' ').trim(); };
    var title = '', line = '', btn = '';
    if (n === 1) { line = fill(on ? t.up1 || 'Add a second [name] ring and enjoy [save2]% savings.' : 'Add a second [name] ring, in its own size and metal.'); btn = 'Build a double stack'; }
    else if (n === 2) { title = fill(t.up2Title || 'Make it a triple stack'); line = fill(on ? t.up2 || 'Add a third [name] ring and unlock [save3]% savings.' : 'Add a third [name] ring to complete the stack.'); btn = 'Add a third ring'; }
    else if (n < MAX_RINGS) { title = fill(t.up3Title || 'Complete your collection'); line = fill(t.up3 || 'Your beehive is growing. Make it uniquely yours.'); btn = n === 3 ? 'Add another ring' : 'Add another ring'; }
    else line = 'Six rings is the most for one stack here. You can add more from your bag.';
    var next = $('[data-stack-next]', box), nh = (title ? '<p class="next-title">' + esc(title) + '</p>' : '') + '<p class="next-line">' + esc(line) + '</p>' +
      (btn ? '<button class="stack-more" type="button" data-action="stack-more"><span aria-hidden="true">+</span> ' + esc(btn) + '</button>' : '');
    if (next.innerHTML !== nh) { var hadFocus = next.contains(document.activeElement); next.innerHTML = nh; if (hadFocus) { var b = $('button', next) || $('[data-ring-card] select', box); if (b) b.focus({ preventScroll: true }); } }
  }
  /* Which of the stack photos matches the choice: gold photos for yellow gold, vermeil and gold-plated; silver photos for
     sterling silver, white gold and platinum; one, two or three rings by the rings of this width. Mixed gold and silver has none. */
  var lookOf = function (value) { var mt = value != null ? metalOf(value) : null; return !mt ? '' : mt.family === 'silver' || mt.family === 'platinum' || mt.look === 'white' ? 'silver' : 'gold'; };
  function stackLook(states) {
    var mine = states.filter(function (x) { return x.r.p.id === stk.main.id; }), looks = {};
    mine.forEach(function (x) { var mo = x.r.p.names.filter(function (nm) { return isMaterial({ name: nm }); })[0], l = mo ? lookOf(x.r.sel[mo]) : ''; if (l) looks[l] = 1; });
    var kinds = Object.keys(looks);
    return { mine: mine, k: Math.min(mine.length, 3), look: kinds[0] || '', mixed: kinds.length > 1 };
  }
  function stackLead() { // the matched photos the main gallery leads with, once a metal is chosen
    if (!stk || !stk.photos || !pv || pv.product.id !== stk.main.id) return null;
    var s = stackLook(stackStates()), mo = pv.product.options.filter(isMaterial)[0], look = s.look, k = s.k;
    if (s.mixed) { look = mo ? lookOf(pv.sel[mo.name]) : ''; k = 1; } // no photo shows a mixed stack: show Ring 01's metal, one ring
    var set = look && stk.photos[look] && stk.photos[look][k];
    if (!set) return null;
    var metal = look === 'gold' ? 'yellow gold' : 'silver', name = stk.name ? stk.name + ' ' : '', what = k === 1 ? 'One ' + name + 'ring' : (k === 2 ? 'Two ' : 'Three ') + name + 'rings stacked';
    return { note: (k === 1 ? 'Shown in ' : (k === 2 ? 'Double stack' : 'Triple stack') + ', shown in ') + metal + (s.mine.length > 3 && !s.mixed ? ' (three rings pictured)' : '') + '.',
      images: ['studio', 'hand'].map(function (v) { return { url: set[v][1], alt: what + ', in ' + metal + (v === 'hand' ? ', worn on the hand' : ''), width: 1000, height: 800, lead: true }; }) };
  }
  function galleryFor(p, sel) {
    var base = baseGallery(p, sel), lead = stackLead();
    if (!lead) return base;
    return { images: lead.images.concat(base.images), note: lead.note + (base.note ? ' ' + base.note.replace(/^Photos show/, 'Other photos show') : '') };
  }
  function regallery() { // a stack or metal change can change the photos the gallery leads with
    if (!pv) return;
    var key = function (g) { return g.images.map(function (im) { return imgKey(im.url); }).join('|') + g.note; }, g = galleryFor(pv.product, pv.sel);
    if (key(g) !== key(pv.gallery)) { pv.gallery = g; pv.img = 0; repaintGallery(); }
  }
  /* The stack photo beside the ring cards: two or three rings, gold or silver, as chosen. Shown only when one photo truly matches. */
  function paintView(states) {
    var fig = $('[data-stack-view]', stk.box); if (!fig || !stk.photos) return;
    var s = stackLook(states), k = s.k, look = s.look || 'gold';
    var set = stk.count > 1 && k > 1 && !s.mixed && stk.photos[look] && stk.photos[look][k] && stk.photos[look][k][stk.view];
    fig.hidden = !set;
    if (!set) return;
    var mine = s.mine, key = look + k + stk.view, img = $('[data-stack-view-img]', fig), metal = look === 'gold' ? 'yellow gold' : 'silver';
    if (stk.shown !== key) {
      stk.shown = key;
      img.srcset = set[0] + ' 560w, ' + set[1] + ' 1000w'; img.sizes = '(max-width: 1000px) calc(100vw - 32px), 560px'; img.src = set[0];
      img.alt = (k === 2 ? 'Two' : 'Three') + ' ' + (stk.name ? stk.name + ' ' : '') + 'rings stacked, in ' + metal + (stk.view === 'hand' ? ', worn on the hand' : '');
      img.classList.remove('is-swap'); void img.offsetWidth; img.classList.add('is-swap');
    }
    $('[data-stack-view-cap]', fig).textContent = mine.length > 3 ? 'A three-ring stack, shown in ' + metal : (k === 2 ? 'Double stack' : 'Triple stack') + ' · shown in ' + metal;
    $$('[data-action="stack-view"]', fig).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-view') === stk.view)); });
  }
  function goCheckout() { // Shopify's own way from the bag to checkout
    var f = document.createElement('form'); f.method = 'post'; f.action = R.cart; f.hidden = true;
    f.innerHTML = '<input type="hidden" name="checkout" value="">'; document.body.appendChild(f); f.submit();
  }
  function addStack(button, thenCheckout) {
    if (!pv || !stk || stk.busy || button.getAttribute('aria-disabled')) return;
    if (missing().length && pv.product.available) return askForOptions();
    if (!buyState().can) return;
    var states = stackStates(), bad = states.filter(function (x) { return !x.ok; })[0];
    if (bad) {
      stk.tried = true; stk.error = bad.msg; stk.html = ''; syncBuy();
      var i = states.indexOf(bad), card = $('[data-ring-card="' + i + '"]', stk.box), sel = card && ($('select[aria-invalid]', card) || $('select', card));
      if (card) card.scrollIntoView({ block: 'center', behavior: 'smooth' });
      if (sel) sel.focus({ preventScroll: true });
      return;
    }
    var items = [], byId = {};
    states.forEach(function (x) { if (byId[x.v.id]) byId[x.v.id].quantity++; else { byId[x.v.id] = { id: x.v.id, quantity: 1 }; items.push(byId[x.v.id]); } });
    var est = estimate(states.map(function (x) { return { p: x.r.p, v: x.v }; })), handles = stk.prods.map(function (p) { return p.handle; });
    var prior = !!(cart && cart.lines.some(function (l) { return handles.indexOf(l.handle) >= 0; })), rings = stk.count, label = button.textContent;
    stk.busy = true; button.setAttribute('aria-disabled', 'true'); button.textContent = 'Adding…';
    return cartOp(async function () {
      var before = {}; items.forEach(function (it) { before[it.id] = qtyOf(cart, it.id); });
      await request(R.cartAdd + '.js', { items: items }); // all rings in one request
      var next = await fetchCart();
      if (items.some(function (it) { return qtyOf(next, it.id) < before[it.id] + it.quantity; })) next.notice = 'Not every ring could be added in the number chosen. Please check your bag.';
      return next;
    }).then(function (ok) {
      stk.busy = false; button.removeAttribute('aria-disabled'); button.textContent = label;
      if (!ok) return ok;
      var qty = items.reduce(function (a, it) { return a + it.quantity; }, 0);
      items.forEach(function (it) { emit('added', { variantId: it.id, quantity: it.quantity }); });
      track('added_to_bag', { product_handle: pv.product.handle, variant_id: items[0].id, quantity: qty, stack_rings: rings, page_version: T.pageVersion || 'standard' });
      track('stack_added', { product_handle: pv.product.handle, rings: rings, lines: items.map(function (it) { return { variant_id: it.id, quantity: it.quantity }; }), estimated_total: est.total, estimated_saving: est.regular - est.total, page_version: T.pageVersion || 'standard' });
      if (stk.on && !prior && cart) { // Shopify's figure is the true one; note quietly when it differs from the page's estimate
        var actual = cart.lines.filter(function (l) { return handles.indexOf(l.handle) >= 0; }).reduce(function (a, l) { return a + Math.max(0, l.original - l.total); }, 0);
        if (Math.abs(actual - (est.regular - est.total)) > items.length) { track('stack_saving_mismatch', { expected: est.regular - est.total, applied: actual, rings: rings }); if (window.console) console.warn('Stack saving shown on the page (' + (est.regular - est.total) + ') differs from what Shopify applied (' + actual + '). Check the stack discounts and the theme setting "Both widths can save in the same order".'); }
      }
      if (thenCheckout) goCheckout(); else open('bag-panel', button);
      return ok;
    });
  }
  var missing = function () { return pv.product.options.filter(function (o) { return pv.sel[o.name] == null; }).map(function (o) { return o.name; }); };
  function matching(sel) {
    return pv.product.variants.filter(function (v) { return v.selectedOptions.every(function (o) { return sel[o.name] == null || sel[o.name] === o.value; }); });
  }
  function currentVariant() { return missing().length ? null : (matching(pv.sel)[0] || null); }
  var listNames = function (names) { names = names.map(function (n) { return n.toLowerCase(); }); return names.length > 1 ? names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1] : names[0]; };
  function priceInfo() {
    var v = currentVariant();
    if (v) return unpriced(v.price) ? { text: 'Price on request' } : { text: money(v.price), compare: v.compareAt ? money(v.compareAt) : '' };
    var nums = matching(pv.sel).map(function (x) { return Number(x.price); }).filter(function (n) { return n > 0; });
    if (!nums.length) return { text: 'Price on request' };
    var min = Math.min.apply(null, nums), max = Math.max.apply(null, nums);
    return { text: (max > min ? 'From ' : '') + money(min) };
  }
  function buyState() { // one place decides what the button and the availability line say
    var p = pv.product, miss = missing(), v = currentVariant();
    if (!p.available) return { can: false, off: true, label: 'Not available', status: 'Not available to order at the moment.' };
    if (miss.length) return { can: false, off: false, label: 'Add to bag', status: 'Choose ' + listNames(miss) + ' to see availability.' };
    if (!v) return { can: false, off: true, label: 'Not offered', status: 'This combination is not offered.' };
    if (!v.available) return { can: false, off: true, label: 'Sold out', status: 'This combination is sold out. Other options may be available.' };
    if (unpriced(v.price)) return { can: false, off: true, label: 'Price on request', status: 'Price on request.' };
    return { can: true, off: false, label: 'Add to bag', ok: true, status: (p.made ? 'Made to order.' : 'Available to order.') + (T.dispatch && !p.production ? ' ' + T.dispatch : '') }; // the production line under the price already gives the timing
  }
  function paintMaterials() { // explain each material, and give the care advice for the kinds of metal this piece comes in
    var mo = pv.product.options.filter(isMaterial)[0], list = $('#pv-materials'), care = $('#pv-care');
    if (!mo) return;
    var rows = mo.values.map(function (v) { var n = materialNote(v, 'note'); return n ? '<div data-material="' + esc(v) + '"><dt>' + esc(v) + '</dt><dd>' + esc(n) + '</dd></div>' : ''; }).join('');
    if (list && rows) { list.innerHTML = rows; $('#pv-materials-row').hidden = false; }
    var seen = {}, html = '';
    mo.values.forEach(function (v) { var mt = metalOf(v), def = mt && (T.materials || {})[mt.family]; if (def && def.care && !seen[mt.family]) { seen[mt.family] = 1; html += '<p><strong>' + esc(def.label) + '.</strong> ' + esc(def.care) + '</p>'; } });
    if (care && html) { care.innerHTML = html; $('#pv-care-row').hidden = false; }
  }
  function syncBuy(focusSel) { // refresh price, option states, availability and button in place; the photo and open sections stay as they are
    if (!pv) return;
    var st = buyState(), pr = priceInfo(), v = currentVariant();
    var price = $('#pv-price'); if (price) price.innerHTML = (pr.compare ? '<s>' + esc(pr.compare) + '</s>' : '') + esc(pr.text);
    $$('#pv-buy .option').forEach(function (set) {
      var name = set.getAttribute('data-option-name'), chosen = pv.sel[name];
      $('[data-chosen]', set).textContent = chosen != null ? chosen : 'Choose one';
      if (pv.error && chosen == null) set.setAttribute('aria-invalid', 'true'); else set.removeAttribute('aria-invalid');
      $$('input[data-option]', set).forEach(function (input) {
        var probe = Object.assign({}, pv.sel); probe[name] = input.value;
        var out = pv.product.available && !matching(probe).some(function (x) { return x.available; });
        var span = input.nextElementSibling, sr = $('.sr', span);
        input.checked = chosen === input.value;
        if (out) { input.setAttribute('data-out', ''); if (!sr) span.insertAdjacentHTML('beforeend', '<i class="sr"> (sold out)</i>'); }
        else { input.removeAttribute('data-out'); if (sr) sr.remove(); }
      });
      var note = $('.option-note', set), text = isMaterial({ name: name }) && chosen ? materialNote(chosen, 'note') : '';
      if (note) { note.textContent = text; note.hidden = !text; }
    });
    $$('#pv-materials [data-material]').forEach(function (row) { var mo = pv.product.options.filter(isMaterial)[0]; row.classList.toggle('is-chosen', !!mo && pv.sel[mo.name] === row.getAttribute('data-material')); });
    var status = $('#pv-status'); if (status) { status.textContent = st.status; status.className = 'status' + (st.ok ? ' is-ok' : st.off ? ' is-off' : ''); }
    paintStack(st, v);
    var many = stk && stk.count > 1, label = many && st.can ? stackLabel(stk.count) : st.label;
    var btn = $('#add-btn'); if (btn && !btn.getAttribute('aria-disabled')) { btn.textContent = label; btn.disabled = !!st.off; }
    var errText = pv.error || (stk && stk.error) || '', err = $('#pv-error'); if (err) { err.textContent = errText; err.hidden = !errText; }
    var idInput = $('#product-form input[type="hidden"][name="id"]'); if (idInput) idInput.value = v ? v.id : '';
    var express = $('[data-express]'); // Buy now: Shopify's button once the choice is complete and orderable, a stand-in that asks for what is missing until then
    if (express) { var ready = st.can && !!v && !many; $('.express-real', express).hidden = !ready; var ask = $('.express-ask', express); ask.hidden = ready; ask.disabled = !!st.off; express.hidden = !!st.off && !missing().length; } // a stack of several variants goes through the bag to Shopify checkout
    try { // keep the address in step with the chosen variant, as Shopify themes do, so the choice survives a refresh or a shared link
      var url = new URL(location.href);
      if (v) url.searchParams.set('variant', v.id); else url.searchParams.delete('variant');
      if (many) url.searchParams.set('stack', Math.min(stk.count, 3)); else url.searchParams.delete('stack');
      history.replaceState(history.state, '', url.toString());
    } catch (e) { /* address stays as it is */ }
    var f = focusSel && $(focusSel); if (f && !openPanel) f.focus({ preventScroll: true });
    syncBuybar();
    emit('change');
  }
  function mainPhoto(im) {
    return picture(im, { eager: true, widths: [600, 900, 1200, 1600], sizes: '(max-width: 1000px) 100vw, 50vw', alt: im.alt || pv.product.title }) + '<span class="zoom-hint" aria-hidden="true">Enlarge</span>';
  }
  function galleryInner() {
    var imgs = pv.gallery.images, cur = imgs[pv.img] || imgs[0];
    var stage = cur ? '<button class="gallery-main" type="button" data-action="zoom" aria-label="Enlarge photo">' + mainPhoto(cur) + '</button>' : '<div class="gallery-main">' + noimg() + '</div>';
    return (imgs.length > 1 ? '<div class="thumbs">' + imgs.map(function (im, i) {
        return '<button class="thumb" type="button" data-action="set-img" data-i="' + i + '"' + (i === pv.img ? ' aria-current="true"' : '') + ' aria-label="Show photo ' + (i + 1) + ' of ' + imgs.length + '">' + picture(im, { widths: [160, 320], sizes: '80px', alt: '' }) + '</button>';
      }).join('') + '</div>' : '') +
      '<div class="gallery-stage">' + stage + (pv.gallery.note ? '<p class="gallery-note">' + esc(pv.gallery.note) + '</p>' : '') + '</div>';
  }
  function showImage(i) { // swap the main photo without rebuilding the page
    pv.img = i;
    var box = $('.gallery-main'), im = pv.gallery.images[i];
    if (box && im) box.innerHTML = mainPhoto(im);
    $$('.thumb').forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
  }
  function repaintGallery() {
    var el = $('#pv-gallery'); if (!el) return;
    el.className = 'gallery' + (pv.gallery.images.length < 2 ? ' gallery-single' : '');
    el.innerHTML = galleryInner();
  }
  function askForOptions() { // the customer tried to add without choosing: say what is missing and take them to it
    pv.error = 'Please choose ' + listNames(missing()) + ' first.';
    syncBuy();
    var set = $$('#pv-buy .option').filter(function (f) { return f.getAttribute('aria-invalid'); })[0];
    if (set) { set.scrollIntoView({ block: 'center', behavior: 'smooth' }); var first = $('input', set); if (first) first.focus({ preventScroll: true }); }
  }
  function addCurrent(button) {
    if (!pv) return;
    if (stk && stk.count > 1) return addStack(button);
    var st = buyState(), v = currentVariant();
    if (missing().length && pv.product.available) return askForOptions();
    if (!st.can || !v || button.getAttribute('aria-disabled')) return;
    var qty = pv.qty, label = button.textContent, title = pv.product.title;
    button.setAttribute('aria-disabled', 'true'); button.textContent = 'Adding…'; // stays focusable, so focus can return here afterwards
    return cartOp(function () { return addLine(v.id, qty, title); }).then(function (ok) {
      button.removeAttribute('aria-disabled'); button.textContent = label;
      if (ok) { emit('added', { variantId: v.id, quantity: qty }); track('added_to_bag', { product_handle: pv.product.handle, variant_id: v.id, quantity: qty, page_version: T.pageVersion || 'standard' }); open('bag-panel', button); }
      return ok;
    });
  }

  /* Compact purchase bar on small screens, shown only after the main button has scrolled out of view. */
  var barQuery = window.matchMedia ? window.matchMedia('(max-width: 1000px)') : { matches: false };
  function syncBuybar() {
    if (!bar) return;
    var btn = $('#add-btn');
    if (!pv || !btn || !barQuery.matches || openPanel) { bar.hidden = true; root.classList.remove('has-buybar'); return; }
    var st = buyState(), show = btn.getBoundingClientRect().bottom < 72;
    $('#buybar-title').textContent = pv.product.title;
    var many = stk && stk.count > 1, est = many ? stackTotal() : null;
    $('#buybar-price').textContent = est ? money(est.total) : priceInfo().text;
    var b = $('#buybar-btn'); b.textContent = st.off ? st.label : (missing().length ? 'Choose options' : many ? stackLabel(stk.count).replace(/ to bag$/, '') : 'Add to bag'); b.disabled = !!st.off;
    bar.hidden = !show; root.classList.toggle('has-buybar', show);
  }
  var ticking = false;
  window.addEventListener('scroll', function () { if (!pv || ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; syncBuybar(); }); }, { passive: true });
  window.addEventListener('resize', syncBuybar);

  /* Enlarged photo: the large file is fetched only when the customer asks for it. */
  var zoom = { i: 0, big: false };
  function paintZoom() {
    var imgs = pv.gallery.images, im = imgs[zoom.i]; if (!im) return;
    var stage = $('#zoom-stage'), full = sized(im.url, 2400);
    stage.classList.toggle('is-big', zoom.big);
    stage.innerHTML = '<button class="zoom-img" type="button" data-action="zoom-toggle" aria-label="' + (zoom.big ? 'Zoom out' : 'Zoom in') + '">' +
      '<img src="' + esc(isShopImg(im.url) ? sized(im.url, 1200) : im.url) + '" alt="' + esc(im.alt || pv.product.title) + '"></button>';
    if (full !== im.url) { var hi = new Image(); hi.onload = function () { var el = $('#zoom-stage img'); if (el && zoom.i === imgs.indexOf(im)) el.src = full; }; hi.src = full; }
    $('#zoom-count').textContent = 'Photo ' + (zoom.i + 1) + ' of ' + imgs.length;
    $$('#zoom-dialog [data-action="zoom-prev"], #zoom-dialog [data-action="zoom-next"]').forEach(function (b) { b.hidden = imgs.length < 2; });
  }
  function zoomStep(n) { var len = pv.gallery.images.length; zoom.i = (zoom.i + n + len) % len; zoom.big = false; paintZoom(); showImage(zoom.i); }

  /* ───────────── Search (Shopify's predictive search) ───────────── */
  var searchSeq = 0;
  async function search(term) {
    var box = $('#search-results'), my = ++searchSeq; term = term.trim();
    if (!term) { box.innerHTML = ''; return; }
    var data;
    try { data = await request(R.predictiveSearch + '.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8'); }
    catch (e) { if (my === searchSeq) box.innerHTML = '<p class="search-none">Press Enter to see results.</p>'; return; }
    if (my !== searchSeq) return;
    var hits = (((data || {}).resources || {}).results || {}).products || [];
    var all = R.search + '?q=' + encodeURIComponent(term) + '&type=product';
    box.innerHTML = hits.length ? hits.map(function (p) {
      var im = p.featured_image && p.featured_image.url ? { url: String(p.featured_image.url).replace(/^https?:/, ''), alt: '', width: p.featured_image.width, height: p.featured_image.height } : null;
      var min = Math.round(parseFloat(p.price_min != null ? p.price_min : p.price) * 100), max = Math.round(parseFloat(p.price_max != null ? p.price_max : p.price) * 100);
      var label = !(max > 0) ? 'Price on request' : (max > min ? 'From ' : '') + money(min > 0 ? min : max);
      return '<a class="result" href="' + esc(p.url) + '"><span class="line-media">' + picture(im, { widths: [120, 240], sizes: '56px', alt: '' }) + '</span>' +
        '<span><b>' + esc(p.title) + '</b></span><p class="price">' + esc(label) + '</p></a>';
    }).join('') + '<p class="search-none"><a class="link" href="' + esc(all) + '">See all results</a></p>'
      : '<p class="search-none">Nothing matches "' + esc(term) + '". Try a piece name, such as ring or necklace.</p>';
  }

  /* ───────────── Events ───────────── */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-action]');
    if (!b) return;
    var act = b.getAttribute('data-action'), id = b.getAttribute('data-id');
    var q = function () { return want[id] != null ? want[id] : lineQty(id); };
    if (act === 'open-bag' && T.template === 'cart') return; // already on the bag page
    if (b.tagName === 'A') e.preventDefault();
    if (act === 'open-menu') open('menu-panel');
    else if (act === 'open-bag') open('bag-panel');
    else if (act === 'open-search') open('search-panel');
    else if (act === 'close-panels') closePanels();
    else if (act === 'line-inc') setLineQty(id, q() + 1);
    else if (act === 'line-dec') setLineQty(id, q() - 1);
    else if (act === 'line-remove') setLineQty(id, 0);
    else if (!pv) return;
    else if (act === 'set-img') showImage(Number(b.getAttribute('data-i')));
    else if (act === 'zoom') { zoom.i = pv.img; zoom.big = false; paintZoom(); open('zoom-dialog', b); }
    else if (act === 'zoom-toggle') { zoom.big = !zoom.big; var stage = $('#zoom-stage'); stage.classList.toggle('is-big', zoom.big); b.setAttribute('aria-label', zoom.big ? 'Zoom out' : 'Zoom in'); if (zoom.big) { stage.scrollLeft = (stage.scrollWidth - stage.clientWidth) / 2; stage.scrollTop = (stage.scrollHeight - stage.clientHeight) / 2; } }
    else if (act === 'zoom-prev') zoomStep(-1);
    else if (act === 'zoom-next') zoomStep(1);
    else if (act === 'tryon') launchTryon(b);
    else if (act === 'size-guide') open('size-dialog', b); // the guide itself is written by the theme (snippets/size-guide.liquid)
    else if (act === 'qty-dec' || act === 'qty-inc') setQty(pv.qty + (act === 'qty-inc' ? 1 : -1));
    else if (act === 'stack-photo') { // the video, when there is one, is only fetched now
      var media = $('[data-stack-media]'), tpl = media && $('template[data-stack-video]', media);
      if (tpl && !$('video', media)) { media.insertBefore(tpl.content.cloneNode(true), tpl); var img = $('img', media); if (img) img.hidden = true; var vid = $('video', media); if (vid) { vid.muted = true; vid.setAttribute('playsinline', ''); var go = vid.play && vid.play(); if (go && go.catch) go.catch(function () { /* still shows its first frame */ }); } }
      open('stack-dialog', b);
    }
    else if (act === 'buybar') { if (missing().length) askForOptions(); else addCurrent(b); }
    else if (act === 'buy-now') { if (missing().length) askForOptions(); else if (stk && stk.count > 1) addStack(b, true); }
    else if (act === 'stack-more' && stk) {
      setCount(stk.count + 1);
      var card = $('[data-ring-card="' + (stk.count - 1) + '"]', stk.box), first = card && $('select', card);
      if (first) first.focus({ preventScroll: true });
      if (card && card.scrollIntoView) card.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
    else if (act === 'stack-remove') removeRing(Number(b.getAttribute('data-ring')));
    else if (act === 'stack-view' && stk) { stk.view = b.getAttribute('data-view') === 'hand' ? 'hand' : 'studio'; syncBuy(); }
  });
  document.addEventListener('submit', function (e) {
    if (e.target.getAttribute('id') !== 'product-form' || !pv) return; // getAttribute: the form holds a field named "id", which would shadow form.id
    e.preventDefault(); // add through the bag panel instead of leaving the page
    addCurrent($('#add-btn'));
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('input[data-stack-n]') && stk) { setCount(Number(t.value)); t.focus({ preventScroll: true }); return; }
    if (t.matches('select[data-ring-opt]') && stk) { // a ring's own size or metal; Ring 01 is the choice on the page itself
      var ri = Number(t.getAttribute('data-ring')), on = t.getAttribute('data-ring-opt'), keep = t.id;
      if (ri === 0) choose(on, t.value);
      else { var rr = stk.rings[ri]; if (rr.linked) { rr.sel = adaptSel(prodOf(rr.pid), pv.sel); rr.linked = false; } rr.sel[on] = t.value; syncBuy(); }
      var back = document.getElementById(keep); if (back) back.focus({ preventScroll: true });
      return;
    }
    if (t.matches('input[data-ring-w]') && stk) { // a fourth ring onwards may be either width
      var wi = Number(t.getAttribute('data-ring-w')), wr = stk.rings[wi], cur = ringAt(wi).sel, np = prodOf(Number(t.value)), wid = t.id;
      wr.sel = adaptSel(np, cur); wr.pid = np.id; wr.linked = false; syncBuy();
      var wb = document.getElementById(wid); if (wb) wb.focus({ preventScroll: true });
      return;
    }
    if (t.matches('input[data-option]') && pv) {
      pv.sel[t.getAttribute('data-option')] = t.value;
      if (!missing().length) pv.error = ''; else if (pv.error) pv.error = 'Please choose ' + listNames(missing()) + ' first.';
      var before = pv.gallery.images.map(function (im) { return imgKey(im.url); }).join('|') + pv.gallery.note;
      pv.gallery = galleryFor(pv.product, pv.sel);
      if (pv.gallery.images.map(function (im) { return imgKey(im.url); }).join('|') + pv.gallery.note !== before) { pv.img = 0; repaintGallery(); }
      else {
        var v = currentVariant();
        if (v && v.image) { var i = pv.gallery.images.map(function (im) { return imgKey(im.url); }).indexOf(imgKey(v.image.url)); if (i >= 0 && i !== pv.img) showImage(i); }
      }
      syncBuy('#' + (window.CSS && CSS.escape ? CSS.escape(t.id) : t.id));
    } else if (t.matches('[data-sort-select]')) {
      var url = new URL(location.href);
      url.searchParams.set('sort_by', t.value); url.searchParams.delete('page');
      location.href = url.toString();
    }
  });
  var searchTimer;
  document.addEventListener('input', function (e) {
    if (e.target.id !== 'search-input') return;
    clearTimeout(searchTimer);
    var val = e.target.value;
    searchTimer = setTimeout(function () { search(val); }, 180);
  });
  document.addEventListener('keydown', function (e) {
    var zooming = openPanel && openPanel.id === 'zoom-dialog';
    if (e.key === 'Escape') closePanels();
    else if (zooming && e.key === 'ArrowLeft') zoomStep(-1);
    else if (zooming && e.key === 'ArrowRight') zoomStep(1);
  });
  var skip = $('.skip');
  if (skip && main) skip.addEventListener('click', function (e) { e.preventDefault(); main.focus({ preventScroll: true }); main.scrollIntoView({ block: 'start' }); });
  /* Returning from checkout with the Back button: re-check the bag, which Shopify empties once an order is paid. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) fetchCart().then(function (c) { cart = c; paintBag(); }).catch(function () { /* keep what is shown */ }); });
  /* Theme editor: sections are redrawn in place while you edit. */
  document.addEventListener('shopify:section:load', function () { adoptMenu(); initProduct(); paintBag(); });

  /* What the try-on script may use from this one. */
  T.bridge = {
    esc: esc, on: on, track: track, note: materialNote, toast: toast, open: open, close: closePanels, metalOf: metalOf, choose: choose,
    isMaterial: isMaterial, sourceFor: function (m) { return pv ? tryonFor(m) : ''; }, materials: function () { return pv ? tryonMaterials() : []; },
    add: function () { return addCurrent($('#add-btn')); }, ask: askForOptions,
    state: function () { return pv ? { product: pv.product, sel: pv.sel, qty: pv.qty, rings: stk ? stk.count : 1, missing: missing(), buy: buyState(), price: priceInfo(), variant: currentVariant(), tryon: pv.tryon, model3d: pv.model3d } : null; }
  };

  /* ───────────── Start ───────────── */
  adoptMenu();
  if (T.cart) cart = normCart(T.cart);
  paintBag();
  initProduct();
})();
